export const styles = {
  sidebar:
    'tw-flex tw-flex-col tw-h-full tw-bg-neutral-900 tw-transition-all tw-duration-300 tw-ease-in-out tw-flex-shrink-0 tw-overflow-hidden',
  sidebarExpanded: 'tw-w-60',
  sidebarCollapsed: 'tw-w-16',

  header:
    'tw-flex tw-items-center tw-h-16 tw-px-4 tw-flex-shrink-0 tw-cursor-pointer hover:tw-bg-neutral-800 tw-transition-colors tw-duration-200 tw-overflow-hidden tw-border-b tw-border-solid tw-border-neutral-800',
  headerAvatar:
    'tw-w-9 tw-h-9 tw-min-w-[2.25rem] tw-rounded-lg tw-bg-primary-600 tw-flex tw-items-center tw-justify-center tw-text-white tw-font-bold tw-text-xs tw-flex-shrink-0',
  headerInfo:
    'tw-ml-3 tw-flex tw-flex-col tw-min-w-0 tw-flex-1 tw-transition-opacity tw-duration-300',
  headerInfoVisible: 'tw-opacity-100',
  headerInfoHidden: 'tw-opacity-0 tw-w-0 tw-overflow-hidden',
  headerName: 'tw-text-white tw-font-semibold tw-text-sm tw-leading-tight tw-truncate',
  headerRole: 'tw-text-neutral-400 tw-text-xs tw-leading-tight tw-truncate',
  headerChevron:
    'tw-text-xs tw-flex-shrink-0 tw-text-neutral-400 tw-transition-opacity tw-duration-300',

  nav: 'tw-flex-1 tw-overflow-y-auto tw-overflow-x-hidden tw-px-3 tw-pt-4',

  section: 'tw-mb-6',

  categoryLabel:
    'tw-px-3 tw-pb-2 tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-primary-400 tw-whitespace-nowrap tw-overflow-hidden tw-transition-opacity tw-duration-300 tw-block',
  categoryLabelVisible: 'tw-opacity-100',
  categoryLabelHidden: 'tw-opacity-0',

  dividerCollapsed: 'tw-mx-2 tw-my-3 tw-border-t tw-border-solid tw-border-neutral-800',

  navList: 'tw-flex tw-flex-col tw-gap-1',

  navItem:
    'tw-flex tw-items-center tw-gap-3 tw-px-3 tw-py-2.5 tw-rounded-lg tw-cursor-pointer tw-transition-all tw-duration-200 tw-text-neutral-400 hover:tw-bg-neutral-800 hover:tw-text-white tw-no-underline tw-relative tw-group tw-overflow-hidden',
  navItemActive:
    'tw-bg-primary-600 tw-bg-opacity-20 tw-text-primary-300 hover:tw-bg-primary-600 hover:tw-bg-opacity-25 hover:tw-text-primary-200',
  navIcon: 'tw-text-lg tw-w-5 tw-text-center tw-flex-shrink-0',
  navLabel:
    'tw-whitespace-nowrap tw-overflow-hidden tw-transition-opacity tw-duration-300 tw-text-[13px] tw-font-medium',
  navLabelVisible: 'tw-opacity-100',
  navLabelHidden: 'tw-opacity-0 tw-w-0',
  tooltip:
    'tw-invisible group-hover:tw-visible tw-absolute tw-left-full tw-ml-2 tw-px-2.5 tw-py-1.5 tw-bg-neutral-700 tw-text-white tw-text-xs tw-rounded-lg tw-whitespace-nowrap tw-z-50 tw-shadow-lg tw-pointer-events-none',

  footer:
    'tw-flex tw-flex-col tw-gap-1 tw-px-3 tw-pb-4 tw-pt-2 tw-border-t tw-border-solid tw-border-neutral-800 tw-flex-shrink-0',
  footerItem:
    'tw-flex tw-items-center tw-gap-3 tw-px-3 tw-py-2.5 tw-rounded-lg tw-cursor-pointer tw-transition-all tw-duration-200 tw-text-neutral-400 hover:tw-bg-neutral-800 hover:tw-text-white tw-overflow-hidden tw-relative tw-group',
  footerItemDanger:
    'tw-flex tw-items-center tw-gap-3 tw-px-3 tw-py-2.5 tw-rounded-lg tw-cursor-pointer tw-transition-all tw-duration-200 tw-text-neutral-400 hover:tw-bg-red-900 hover:tw-bg-opacity-30 hover:tw-text-red-400 tw-overflow-hidden tw-relative tw-group',
  footerIcon: 'tw-text-lg tw-w-5 tw-text-center tw-flex-shrink-0',
  footerIconWrapper: 'tw-relative tw-flex-shrink-0',

  badge:
    'tw-absolute -tw-top-1.5 -tw-right-2 tw-min-w-[18px] tw-h-[18px] tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-red-500 tw-text-white tw-text-[10px] tw-font-bold tw-leading-none tw-px-1',
  badgeInline:
    'tw-ml-2 tw-inline-flex tw-items-center tw-justify-center tw-min-w-[20px] tw-h-5 tw-rounded-full tw-bg-red-500 tw-text-white tw-text-[11px] tw-font-bold tw-leading-none tw-px-1.5',
};
